import { render, staticRenderFns } from "./CompanyTagsPage.vue?vue&type=template&id=b3402cd4&scoped=true"
import script from "./CompanyTagsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyTagsPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompanyTagsPage.vue?vue&type=style&index=0&id=b3402cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3402cd4",
  null
  
)

export default component.exports